import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import {
  CampaignRequestProgramStageEnum,
  CustomerPermissionActionEnum,
  CustomerPermissionSubjectEnum,
  OrganizationAccessControlModuleEnum,
  type components,
} from '@/libs/openapi/schema';
import { hasPermissions, hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

export const campaignRequestProgramPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(hasModule(globalCtx.organization, OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
  create: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  update: (ctx: Pick<components['schemas']['CampaignRequestProgramResponseDto'], 'stage'>) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(
      ctx.stage !== CampaignRequestProgramStageEnum.COMPLETED &&
      ctx.stage !== CampaignRequestProgramStageEnum.LOST,
    ),
  ]),
  updateOwner: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
